<template>
  <div
    :class="{
      'flex h-full flex-col rounded-t-5px border border-b-5px border-b-www-color-primary-lighter bg-www-color-white': true,
      'border-www-color-neutral-very-light hover:border-www-color-neutral-light hover:border-b-www-color-primary-lighter': true,
      'transition-all duration-300 ease-in-out': true,
    }"
  >
    <div
      :class="{
        'img-contianer h-52': true,
      }"
    >
      <PTCLink
        v-if="data?.currentPathname"
        :to="`${data.currentPathname}`"
        :class="{
          'block h-full overflow-hidden': true,
        }"
      >
        <img
          v-if="data?._type === 'video'"
          :src="data.wistiaVideoMetadata?.thumbnailUrl ?? ''"
          alt="video thumbnail"
          :class="{
            'h-full w-full rounded-t-5px object-cover': true,
          }"
        />

        <PtcPicture
          v-else
          provider="sanity"
          :src="data?.cardImage?.asset?._ref ?? ''"
          :img-attrs="{
            class: { 'aspect-video object-cover object-center rounded-t-5px w-full': true },
          }"
          :class="{
            'block h-full w-full': true,
          }"
          :modifiers="{
            crop: data?.cardImage?.crop,
            hotspot: data?.cardImage?.hotspot,
            w: 500,
          }"
          :alt="resolvedImage?.altText || 'manual card image'"
        />
      </PTCLink>
    </div>
    <div
      :class="{
        'flex-grow px-6 pb-4 pt-8 text-www-color-neutral-medium-dark': true,
      }"
    >
      <PTCLink
        v-if="data?.currentPathname"
        :to="`${data.currentPathname}`"
      >
        <h5
          :class="{
            'text-xl font-black text-www-color-neutral-medium-dark': true,
          }"
        >
          {{ data?.title }}
        </h5>
      </PTCLink>
      <p
        v-if="data?.articleDate"
        :class="{
          'my-10px text-10px text-www-color-neutral-medium-dark': true,
        }"
      >
        {{ formatDateUTC(data?.articleDate, 'MM.DD.YYYY') }}
      </p>
      <p
        :class="{
          'flex-grow text-15px leading-7 text-www-color-neutral-medium-dark lg:line-clamp-5': true,
        }"
      >
        {{ data?.description }}
      </p>
    </div>
    <PTCLink
      v-if="data?.currentPathname"
      :to="`${data.currentPathname}`"
    >
      <p
        :class="{
          'inline-flex gap-2.5 px-6 py-22px font-ptc-Rajdhani text-base font-bold uppercase text-www-color-primary-lighter': true,
        }"
      >
        <span>
          {{ data.cardButtonText }}
        </span>

        <PtcIcon
          name="ptc-arrow-white"
          alt="arrow"
          :class="{
            'text-www-color-primary-lighter': true,
          }"
        />
      </p>
    </PTCLink>
  </div>
</template>

<script lang="ts" setup>
import type { ReferenceCard } from '~/sanity/types';
import { useRefsStore } from '~/composables/refsStore';
import PTCLink from '~/components/Atmos/PTCLink/PTCLink.vue';
import PtcPicture from '~/components/Atmos/PtcPicture/PtcPicture.vue';
import PtcIcon from '~/components/Atmos/PtcIcon/PtcIcon.vue';

const { getResolvedReferenceCard, getResolvedImage } = useRefsStore();
const props = defineProps<ReferenceCard>();
const data = await getResolvedReferenceCard(props.selectedPage?.reference?._ref);
const resolvedImage = await getResolvedImage(data.value?.cardImage?.asset?._ref);
</script>
